import { cn } from '@/lib/utils';
import { initials } from '@/lib/format';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';

/** Initials avatar on the brand tile (no photos in P1); decorative — the name is always printed next to it. */
export function UserAvatar({ name, email, size = 36, className }: { name?: string | null; email?: string; size?: number; className?: string }) {
  return (
    <Avatar aria-hidden className={cn('shrink-0', className)} style={{ width: size, height: size }}>
      <AvatarFallback className="bg-primary font-semibold text-primary-foreground" style={{ fontSize: Math.round(size * 0.36) }}>
        {initials(name, email)}
      </AvatarFallback>
    </Avatar>
  );
}
